import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducers from "./reducer";
import rootSaga from "./root.saga";


// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Create store with saga middleware
const store = createStore(rootReducers, applyMiddleware(sagaMiddleware));

// Run the root saga
// sagaMiddleware.run(rootSaga);

sagaMiddleware.run(function* () {
	yield rootSaga();
});

export default store;
